import configureMeasurements, {
  AllMeasures,
  allMeasures,
  AllMeasuresUnits,
} from 'convert-units';
import Router from 'next/router';

const convert = configureMeasurements(allMeasures);

export const SUPPORTED_UNITS = new Set([
  'mg',
  'g',
  'kg',
  'mt',
  't',
  'lb',
  'oz',
  'ml',
  'l',
  'mm3',
  'cm3',
  'm3',
  'fl-oz',
  'cup',
  'gal',
  'ft3',
  'in3',
  'yd3',
]);

export const getUnitName = (unit: string | undefined) => {
  if (unit?.toLowerCase().includes('seed')) {
    const seedsMap = {
      en: 'Seed',
      ar: 'بذرة',
      es: 'Semilla',
      fr: 'Graine',
      ka: 'თესლი',
    } as const;

    return seedsMap[Router.locale as keyof typeof seedsMap];
  }

  try {
    return convert?.()?.describe?.(unit as AllMeasuresUnits)?.singular;
  } catch (error) {
    return '';
  }
};

export const getMeasurementUnits = (
  measure: AllMeasures | 'weight' | 'seeds',
  system?: string
) => {
  if (measure === 'seeds') return ['seeds'];
  try {
    return convert()
      ?.list?.(measure === 'weight' ? 'mass' : measure)
      ?.filter(
        (unit) =>
          SUPPORTED_UNITS.has(unit.abbr) && (!system || unit.system === system)
      )
      .map((unit) => unit.abbr);
  } catch (error) {
    return [];
  }
};
